import { render } from "./Noticia.vue?vue&type=template&id=e2b495bc&scoped=true"
import script from "./Noticia.vue?vue&type=script&lang=js"
export * from "./Noticia.vue?vue&type=script&lang=js"

import "./Noticia.vue?vue&type=style&index=0&id=e2b495bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b495bc"]])

export default __exports__